// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"485304af","535":"4ba0bbd2","831":"d4d739a9","846":"5ee99b95"}[chunkId] + ".chunk.css";
};